__turbopack_context__.v({
  "Address": "QhVzDW_Address",
  "AddressLinkList": "QhVzDW_AddressLinkList",
  "Arrow": "QhVzDW_Arrow",
  "Center": "QhVzDW_Center",
  "Column": "QhVzDW_Column",
  "Container": "QhVzDW_Container",
  "Content": "QhVzDW_Content",
  "EmailLinkWrapper": "QhVzDW_EmailLinkWrapper",
  "EmailWrapper": "QhVzDW_EmailWrapper",
  "Label": "QhVzDW_Label",
  "Last": "QhVzDW_Last",
  "Link": "QhVzDW_Link",
  "LinkTitle": "QhVzDW_LinkTitle",
  "Links": "QhVzDW_Links",
  "LinksAddressWrapper": "QhVzDW_LinksAddressWrapper",
  "LinksWrapper": "QhVzDW_LinksWrapper",
  "Logo": "QhVzDW_Logo",
  "LogoNameWrapper": "QhVzDW_LogoNameWrapper",
  "LogoWrapper": "QhVzDW_LogoWrapper",
  "Root": "QhVzDW_Root",
  "Video": "QhVzDW_Video",
  "VideoContainer": "QhVzDW_VideoContainer",
  "VideoEarth": "QhVzDW_VideoEarth",
  "Wide": "QhVzDW_Wide",
  "skeleton-loading": "QhVzDW_skeleton-loading",
});
